import React from "react";
import {
  StyledContentWrapper,
  StyledImagesWrapper,
  StyledSectionWrapper,
  StyledTitle,
  StyledDescriptions,
  StyledSectionContainer
} from "./ui";
import { Box, Span } from "../../assets/ui";

const VenueCalendar = () => {
  return (
    <StyledSectionWrapper>
      <StyledSectionContainer>
        <StyledTitle>
          <p>
            <span>Venues</span>
          </p>
          <h3>
            Exsportia <Span color="#32D882">VMS</Span> <br />
            Sports business management for the new world.
          </h3>
        </StyledTitle>

        <StyledContentWrapper>
          <StyledDescriptions>
            <p>
              Whether your a Multi sport facility, a private home or or a PT.
              Our tools automate and manage your whole sports business.
            </p>
            <p>
              Creating accessibility to participants means anyone can convert
              there space to sustainable income.
            </p>
            <Box
              pl="16px"
              borderLeft="3px solid #15EF81"
              fontSize="18px"
              lineHeight="24px"
              color="#586981"
              mt="42px"
              mb={"16px"}
            >
              With complete all-round customisations our software can be adapted
              to every sport and any environment.
            </Box>
          </StyledDescriptions>

          <StyledImagesWrapper>
            <img src="./images/venue-calendar.png" alt="" />
          </StyledImagesWrapper>
        </StyledContentWrapper>
      </StyledSectionContainer>
    </StyledSectionWrapper>
  );
};

export default VenueCalendar;
